import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
const baseURL = process.env.REACT_APP_BASE_URL;

interface SettingItem {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

const ChangePassword = () => {
  const [password, setPassword] = useState<SettingItem>({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  // Handle text input changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPassword((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

   const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    navigate("/login");
  };

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const { oldPassword, newPassword, confirmPassword } = password;

    // Validation
    if (!oldPassword || !newPassword || !confirmPassword) {
        toast("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast('New password and confirm password do not match.');
      return;
    }

    let token = localStorage.getItem("token")

    try {
      const response = await axios.post(
        `${baseURL}/admin/changepassword`,
        { token, oldPassword, newPassword, confirmPassword },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );

      toast(response.data.message || 'Password changed successfully!');
      setPassword({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
      handleLogout();
    } catch (error) {
      console.error('Error updating password:', error);
      toast(
        error.response?.data?.message || 'Failed to update password. Please try again.'
      );
    }
  };

  return (
    <div className='ml-0 lg:ml-[256px] p-4'>
      <h2 className='text-2xl font-semibold mb-4 text-white'>Change Password</h2>
      <form onSubmit={handleSubmit} className='space-y-4 mb-10'>
        <div>
          <label className="text-white">Old Password</label>
          <input
            type='password'
            name='oldPassword'
            value={password.oldPassword}
            onChange={handleChange}
            className='border rounded p-2 w-full'
          />
        </div>
        <div>
          <label className="text-white">New Password</label>
          <input
            type='password'
            name='newPassword'
            value={password.newPassword}
            onChange={handleChange}
            className='border rounded p-2 w-full'
          />
        </div>
        <div>
          <label className="text-white">Confirm Password</label>
          <input
            type='password'
            name='confirmPassword'
            value={password.confirmPassword}
            onChange={handleChange}
            className='border rounded p-2 w-full'
          />
        </div>
        <button type='submit' className='bg-blue-500 text-white py-2 px-4 rounded'>
          Change Password
        </button>
      </form>
      <hr className='p-5' />
    </div>
  );
};

export default ChangePassword;
